import _                                                                                               from 'underscore';
import classNames                                                                                      from 'classnames';
import React, { FC, ReactNode, useState }                                                              from 'react';
import { Button, ButtonProps, Header, Icon, IconProps, Label, List, Popup, PopupProps, SemanticICONS } from 'semantic-ui-react';
import { Align, SemanticUIColor, Size, SystemEvent }                                                   from '../../types';
import { StyledContainer }                                                                             from './StyledContainer';
import { EMPTY_VALUE_DISPLAY }                                                                         from '../../constants/FormatStringEnums';

interface ToolBarProps {
	label?: string,
	items: ToolBarItemAction[]
}

export interface ToolBarItemAction extends ToolBarItemProps {
	isPopup?: boolean,
	popupContent?: ReactNode,
	popupBorderColor?: SemanticUIColor,
}

export interface ToolBarItemProps {
	label: null | false | string | ReactNode,
	icon: null | false | SemanticICONS | IconProps,
	popup?: null | PopupProps,
	enabled?: boolean,
	showActivityDot?: boolean
	content?: ReactNode,

	onClick?: ButtonProps['onClick'],
}

const toolBarDefaultProps: ToolBarProps = {
	label: 'Tools',
	items: [],
}

const ToolBar: FC<ToolBarProps> = ( props ) => {

	return (

		<>
			<List className={ 'text-center' }>

				<List.Item className={ 'margin-md-vertical' }>
					<Header as={ 'h5' }>{ props.label }</Header>
				</List.Item>

				{ props.items.map( ( item, index ) => {

					let { isPopup, popup = {}, popupContent, ...itemProps } = item;

					return ( props.children ??
						<List.Item key={ index } className={ 'no-padding position--relative' }>

							{ isPopup ? (

								<Popup flowing
								       pinned
								       popperModifiers={{
									       preventOverflow: {
										       boundariesElement: "window"
									       }
								       }}
								       position={ 'left center' }
								       content={ popupContent }
								       trigger={ <ToolBarItem { ...itemProps }/> }
								       closeOnPortalMouseLeave={ false }
								       closeOnEscape={ true }
								       style={ item.popupBorderColor ? {
									       borderTop:    `3px solid var(--color-${ item.popupBorderColor })`,
									       borderRadius: `5px`,
								       } : {} }
								       { ...popup }
								/>

							) : (

								  <ToolBarItem { ...itemProps }/>

							  ) }

						</List.Item>
					)
				} ) }

			</List>
		</>
	);
};

const toolBarItemDefaultProps: ToolBarItemProps = {
	label:           EMPTY_VALUE_DISPLAY,
	icon:            'cog',
	enabled:         true,
	showActivityDot: false,
	content:         null,

	onClick: () => {},
}

const ToolBarItem: FC<ToolBarItemProps> = ( props ) => {

	return (

		<Button onClick={ props.onClick || null } basic compact fluid className={ 'border--hover no-margin no-box-shadow position--relative' } disabled={ ( props.enabled === false ) }>

			{ props.enabled && props.showActivityDot && <Label empty circular corner={ 'right' } color={ 'red' } style={ { top: 10, right: 20 } } className={ 'pulse-red' }/> }

			<StyledContainer padding={ [ Size.SM, null ] }
			                 textAlign={ Align.CENTER }
			                 className={ classNames( {
				                 'opacity--50':        !props.enabled,
				                 'opacity--80':        props.enabled,
				                 'opacity-hover--100': true,
			                 } ) }>

				{/* ICON */ }
				{ ( props.icon && _.isObject( props.icon ) ) ? <Icon { ...props.icon } /> : <Icon name={ props.icon as SemanticICONS } fitted/> }

				{/* LABEL */ }
				{ props.label && (

					<h6 className={ classNames( 'no-margin padding-xs-top', {
						'opacity--50':  !props.enabled,
						'opacity--100': props.enabled
					} ) }>{ props.label }</h6>

				) }

			</StyledContainer>

			{/* ADDITIONAL CONTENT */ }
			{ props.content }

		</Button>

	);
}

ToolBar.defaultProps     = toolBarDefaultProps;
ToolBarItem.defaultProps = toolBarItemDefaultProps;

export { ToolBar, ToolBarItem }
